export const currentDate = new Date().toJSON().slice(0, 10);
